import React from 'react';
import './SharedSidebar.css';

interface SharedSidebarProps {
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  title?: string | React.ReactNode;
  subtitle?: string;
}

const SharedSidebar: React.FC<SharedSidebarProps> = ({ 
  isOpen, 
  onToggle, 
  children,
  title,
  subtitle
}) => {
  return (
    <>
      {/* Sidebar Toggle Button */}
      <button 
        className={`sidebar-toggle ${isOpen ? 'open' : ''}`} 
        onClick={onToggle}
      >
        <span className="material-icons">{isOpen ? 'close' : 'menu'}</span>
      </button>

      {/* Sidebar Overlay */}
      <div className={`sidebar-overlay ${isOpen ? 'open' : ''}`}>
        {(title || subtitle) && (
          <div className="sidebar-header">
            {title && <div className="sidebar-title">{title}</div>}
            {subtitle && <div className="sidebar-subtitle">{subtitle}</div>}
          </div>
        )}
        
        <div className="sidebar-content">
          {children}
        </div>
      </div>
    </>
  );
};

export default SharedSidebar;